import { NgModule, Optional, SkipSelf } from '@angular/core';
import {downgradeComponent, downgradeInjectable} from '@angular/upgrade/static';

import {
  WebCommonAngularJSModule,
} from 'webcommon/ajs';
import {
  VersionService,
} from 'webcommon/common-api';
import {
  APFacilityPortalComponent,
  FacilityPortalModule,
  FpSearchService,
  FpResultsComponent,
  FpResultsService,
} from 'webcommon/facility-portal';
import {UrlParsingService} from 'webcommon/legacy-common';

@NgModule({
  imports: [
    WebCommonAngularJSModule,

    // I'm only importing this because it's using angular-material, and there is an error if the angular-material module
    // that we are trying to use has "providers" (like MatChipsModule),
    // and is not imported in the root AppModule or some dependency module of AppModule.
    // Currently, FacilityPortalModule is not imported anywhere else, and is only being referenced to downgradeComponents
    // to be used in ajs. (like APFacilityPortalComponent)
    // Error:
    // NullInjectorError: R3InjectorError(AppModule)[InjectionToken mat-chips-default-options ->
    // InjectionToken mat-chips-default-options -> InjectionToken mat-chips-default-options]:
    // NullInjectorError: No provider for InjectionToken mat-chips-default-options!
    //
    // More info:
    // https://github.com/angular/angular/issues/35759
    // https://stackoverflow.com/a/69157342/5335355
    // https://stackoverflow.com/a/65191317/5335355
    // Theoretically, we don't need to import every module here that we are downgrading components for,
    // and this is a specific issue with angular-material.
    FacilityPortalModule,
  ],
})
export class FacilityPortalAngularJSModule {
  // This is using the same constructor pattern as BrowserModule
  constructor(
    @Optional() @SkipSelf() parentModule: FacilityPortalAngularJSModule | null,
  ) {
    if (parentModule) {
      throw new Error(
        `FacilityPortalAngularJSModule is already loaded. Import it only once, usually in the AppModule only`);
    }
  }

  /* eslint-disable max-len */
  static registerAngularJS(module: angular.IModule): void {
    WebCommonAngularJSModule.registerAngularJS(module);

    module
      .factory(FpSearchService.ajsFactoryName, downgradeInjectable(FpSearchService))
      .factory(FpResultsService.ajsFactoryName, downgradeInjectable(FpResultsService))
      .factory(UrlParsingService.ajsFactoryName, downgradeInjectable(UrlParsingService))
      .factory(VersionService.ajsFactoryName, downgradeInjectable(VersionService));

    module
      .directive(APFacilityPortalComponent.ajsComponentName, downgradeComponent({ component: APFacilityPortalComponent }))
      .directive(FpResultsComponent.ajsComponentName, downgradeComponent({ component: FpResultsComponent }));
  }
  /* eslint-enable max-len */
}
